import { Card } from '@/components/ui/card';
import { RouteItem } from './route-item';

interface TransportRoutesProps {
  routes: Array<{
    from: { name: string };
    to: { name: string };
    value: number;
    type: string;
  }>;
  formatNumber: (num: number) => string;
}

export function TransportRoutes({ routes, formatNumber }: TransportRoutesProps) {
  return (
    <Card className="p-6">
      <h3 className="text-lg font-semibold mb-4">Transport Routes</h3>
      <div className="space-y-3 max-h-96 overflow-y-auto">
        {routes.map((route, index) => (
          <RouteItem key={index} route={route} formatNumber={formatNumber} />
        ))}
      </div>
    </Card>
  );
}
